import { Controller } from "@hotwired/stimulus"

// Site (Company) detail V2 (Hotwire) shell. The page mixes links to the
// migrated V2 (Hotwire) tabs with links that still leave for the React/Inertia
// app (unmigrated tabs, breadcrumbs, the back chevron, the switch-back banner,
// cross-entity links inside a tab body).
//
// A Turbo Drive visit into a React page caches the V2 snapshot and, on browser
// Back, restores it on top of Inertia's leftover <dialog> elements — the V2 tab
// then renders inside a modal (CONEK-7133 review finding). Links that LEAVE the
// /v2 surface must therefore be full page loads. This controller stamps
// data-turbo="false" on every same-origin link on the page whose path is not
// under /v2, while V2↔V2 links (tabs, sort, pagination) keep Turbo for fast nav.
//
// Runs on connect (which Turbo re-fires on each render), so links added by a
// Turbo frame/stream update are covered too.
export default class extends Controller {
  connect() {
    this.markExternalLinks()
  }

  markExternalLinks() {
    const links = this.element.querySelectorAll("a[href]:not([data-turbo])")
    links.forEach((link) => {
      let url
      try {
        url = new URL(link.href, window.location.origin)
      } catch {
        return
      }
      if (url.origin !== window.location.origin) return
      if (url.pathname.includes("/v2/")) return

      link.setAttribute("data-turbo", "false")
    })
  }
}
